import { Icon } from "./icons.tsx"

export type SystemStateKind = "maintenance" | "update"

const presentations = {
  maintenance: {
    description: "점검이 끝날 때까지 현재 화면을 그대로 두고 잠시 후 다시 확인해 주세요.",
    heading: "안전한 이용을 위해 잠시 점검하고 있습니다",
    icon: "notice",
    pageHeading: "서비스 점검 중",
  },
  update: {
    description: "이용 중인 앱을 최신 버전으로 업데이트한 뒤 다시 열어 주세요.",
    heading: "최신 버전에서 계속할 수 있습니다",
    icon: "status",
    pageHeading: "업데이트 필요",
  },
} as const satisfies Readonly<Record<SystemStateKind, { readonly description: string; readonly heading: string; readonly icon: "notice" | "status"; readonly pageHeading: string }>>

export const SystemStatePanel = ({ kind }: { readonly kind: SystemStateKind }) => {
  const presentation = presentations[kind]
  return (
    <>
      <h1 className="state-route-heading">{presentation.pageHeading}</h1>
      <output aria-live="polite" className={`state-panel system-state-panel system-state-${kind}`} data-system-state={kind}>
        <span className="state-icon" data-state-icon={presentation.icon}>
          <Icon name={presentation.icon} />
        </span>
        <h2>{presentation.heading}</h2>
        <p className="phrase-safe-block">{presentation.description}</p>
      </output>
    </>
  )
}
